import {
  faTrashCan,
  faClockRotateLeft,
} from "@fortawesome/pro-solid-svg-icons";
import type { BatchAction } from "@components/CatalogIndex";

export type LobTab = "active" | "archived";

export interface BatchActionHandlers {
  onDelete: () => void;
  onRestore: () => void;
}

export const buildLobBatchActions = (
  tab: LobTab,
  _selectedCount: number,
  handlers: BatchActionHandlers
): BatchAction[] =>
  tab === "archived"
    ? [
        {
          icon: faClockRotateLeft,
          label: "Restore",
          onClick: handlers.onRestore,
        },
      ]
    : [
        {
          icon: faTrashCan,
          label: "Delete",
          onClick: handlers.onDelete,
          variant: "danger",
        },
      ];
